"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
var _lodash = require("lodash");
var _reactIntl = require("react-intl");
var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));
var _charts = require("../../utils/charts");
var style = {
  "loader": "au_line_chart-module__loader___Dohgd",
  "container": "au_line_chart-module__container___xC9WT",
  "svg": "au_line_chart-module__svg___Adu80",
  "tooltip": "au_line_chart-module__tooltip___J7tdh"
};
class AuLineChart extends _react.default.Component {
  constructor(props) {
    var _context;
    super(props);
    this.shouldComponentUpdate = (0, _bind.default)(_charts.shouldComponentUpdate).call(_charts.shouldComponentUpdate, this);
    this.tooltipContent = (0, _bind.default)(_context = this.tooltipContent).call(_context, this);
  }
  tooltipContent({
    payload
  }) {
    if ((0, _isArray.default)(payload) && payload.length) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: style.tooltip
      }, (0, _lodash.round)(payload[0].value, this.props.precision || 0));
    }
    return false;
  }
  renderTitle() {
    const {
      titleId,
      title
    } = this.props;
    if (titleId) {
      return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: titleId,
        children: msg => /*#__PURE__*/_react.default.createElement("h3", null, msg)
      });
    } else {
      return /*#__PURE__*/_react.default.createElement("h3", null, title);
    }
  }
  renderLoading() {
    if (this.props.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: style.loader
      }, /*#__PURE__*/_react.default.createElement(_LoadingIndicator.default, null));
    }
    return false;
  }
  render() {
    if (!this.props.imData) {
      return false;
    }
    let data = this.props.imData.toJS();
    if (this.props.isLoading) {
      // Set the values to zero and add loading indicator to container
      data = (0, _map.default)(data).call(data, x => {
        x.val = 0;
        return x;
      });
    }
    if (!data.length) {
      return false;
    }
    let tickNum = -1;
    function yAxisTickFormatter(tickVal) {
      ++tickNum;
      return tickNum % 2 ? tickVal : ''; // Display every other tick
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: style.container
    }, this.renderTitle(), this.renderLoading(), /*#__PURE__*/_react.default.createElement("div", {
      className: style.svg
    }, /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, null, /*#__PURE__*/_react.default.createElement(_recharts.LineChart, {
      data: data,
      margin: {
        top: 5,
        right: 0,
        left: 0,
        bottom: 0
      }
    }, /*#__PURE__*/_react.default.createElement(_recharts.CartesianGrid, {
      fill: "white",
      vertical: false
    }), /*#__PURE__*/_react.default.createElement(_recharts.YAxis, {
      padding: {
        top: 20
      },
      width: 40,
      orientation: "right",
      scale: "linear",
      tickFormatter: yAxisTickFormatter,
      domain: ['auto', 'auto'],
      axisLine: false,
      tickLine: false,
      allowDecimal: false,
      tickCount: 8,
      tickSize: 4
    }), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, {
      padding: {
        right: 10
      },
      dataKey: "periodStart",
      tickFormatter: ts => (0, _charts.formatDate)(ts, this.props.lang, {
        month: 'numeric',
        day: 'numeric'
      }),
      axisLine: false,
      tickLine: false
    }), /*#__PURE__*/_react.default.createElement(_recharts.Line, {
      dataKey: "val",
      dot: false,
      type: "monotone",
      isAnimationActive: false
    }), /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
      animationDuration: 0,
      animationEasing: "linear",
      cursor: false,
      content: this.tooltipContent
    })))));
  }
}
exports.default = AuLineChart;
AuLineChart.propTypes = _charts.propTypes;
AuLineChart.defaultProps = _charts.defaultProps;